@if (answer$ | async; as answer) {
  <div
    class="flex max-h-40 md:max-h-80 w-full flex-col overflow-y-auto border-b-2 border-t-2 border-modules-eclass-100 bg-modules-eclass-50 p-5 shadow-inner shadow-modules-eclass-100"
  >
    <table class="table w-full">
      <tbody
        class="&>tr>td]:px-3 [&>tr:nth-child(even)]:bg-modules-eclass-100 [&>tr:nth-child(odd)]:bg-base-gray-light-50 [&>tr>td:first-child]:rounded-l-lg [&>tr>td:last-child]:rounded-r-lg"
      >
        @for (attachment of attachments; track attachment) {
          <tr>
            <td>
              <div
                [ngClass]="{
                  'bg-base-gray-light-50': !attachment.viewed_at,
                  'active bg-modules-eclass-500': attachment.id === attachmentSelected?.id,
                }"
                class="flex h-[44px] w-full flex-row justify-between items-center gap-1 rounded-lg sm:gap-4 md:px-5"
              >
                <svg-icon
                  (click)="onSelect(attachment)"
                  class="cursor-pointer text-base-status-info-400 group-active:text-white sm:min-w-[1rem] md:w-6"
                  src="assets/icons/icon-view.svg"
                ></svg-icon>
                <svg-icon
                  class="text-base-genoa-500 sm:min-w-[1rem] md:w-6"
                  [src]="onGetIcon(attachment.extension)"
                ></svg-icon>
                <div (click)="onSelect(attachment)" class="flex h-full w-full flex-col items-start justify-center">
                  <span
                    class="font-goldplay w-30 md:w-60 truncate text-base font-semibold leading-none text-base-gray-light-950 group-active:text-base-gray-light-50"
                  >
                    {{ attachment.title }}
                  </span>
                  <span
                    class="font-goldplay text-base font-normal leading-none text-base-gray-light-800 group-active:text-base-gray-light-100"
                  >
                    {{ attachment.created_at | dateTranslate: 'medium' }}
                  </span>
                </div>
                <svg-icon
                  (click)="onDownloadFile(attachment)"
                  class="min-w-[1.5rem] mr-4 cursor-pointer text-modules-eclass-500 group-active:text-base-gray-light-50 md:w-6"
                  src="assets/icons/icon-download.svg"
                ></svg-icon>
              </div>
            </td>
          </tr>
        }
      </tbody>
    </table>
  </div>
}
